/**
 * Подтягивает баланс с сервера, когда игрок возвращается в приложение
 * или переключает экран. Без этого корректировки админа и пополнения
 * видны только после полной перезагрузки мини-аппа.
 */

import { useEffect } from "react";

import { getWebApp } from "../lib/telegram";
import { useSession } from "../store/session";

const POLL_MS = 15_000;

export function useBalanceSync(screen: string): void {
  const status = useSession((state) => state.status);
  const refreshProfile = useSession((state) => state.refreshProfile);

  useEffect(() => {
    if (status !== "ready") return;
    void refreshProfile();
  }, [screen, status, refreshProfile]);

  useEffect(() => {
    if (status !== "ready") return;

    const sync = () => {
      void refreshProfile();
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") sync();
    };

    document.addEventListener("visibilitychange", onVisibility);

    const app = getWebApp();
    app?.onEvent("activated", sync);

    const timer = window.setInterval(() => {
      if (document.visibilityState === "visible") sync();
    }, POLL_MS);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      app?.offEvent("activated", sync);
      clearInterval(timer);
    };
  }, [status, refreshProfile]);
}
